import { render, staticRenderFns } from "./ChatDirectMessages.vue?vue&type=template&id=54f06ada&scoped=true"
import script from "./ChatDirectMessages.vue?vue&type=script&lang=ts"
export * from "./ChatDirectMessages.vue?vue&type=script&lang=ts"
import style0 from "./ChatDirectMessages.vue?vue&type=style&index=0&id=54f06ada&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f06ada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f06ada')) {
      api.createRecord('54f06ada', component.options)
    } else {
      api.reload('54f06ada', component.options)
    }
    module.hot.accept("./ChatDirectMessages.vue?vue&type=template&id=54f06ada&scoped=true", function () {
      api.rerender('54f06ada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/ChatDirectMessages.vue"
export default component.exports